module.exports = __webpack_public_path__ + "static/love-174627d1dc7e5bf5e6d3595bb15e5335.svg";